import React from 'react';

import { CartLayout } from '@sharedComponents/Layout';
import { ReactFCV } from '@types';
import { CypressTestNamespace } from '@utils/test';

import { BodyColumn, IconColumn, InfoColumn } from './componentHelpers';
import { useBenefitFormattedContent } from './hooks/useBenefitFormattedContent';
import { IBenefitItem } from './model';

export const LoyaltyFreeDeliveryItem: ReactFCV<IBenefitItem> = (benefit) => {
  const { getBenefitBody, getBenefitTitle } = useBenefitFormattedContent(benefit);

  return (
    <CartLayout
      className={CypressTestNamespace.ECartPageBenefits.FREE_DELIVERY_BENEFIT}
      serviceDisabled={false}
      serviceActive={true}
      iconColumn={IconColumn}
      bodyColumn={BodyColumn(benefit, getBenefitTitle)}
      infoColumn={InfoColumn(getBenefitBody)}
    />
  );
};
